import { graphql, useStaticQuery } from 'gatsby';
import { useAtom } from 'jotai';
import { useEffect } from 'react';

import { DropdownButton } from 'voom-gatsby';

import { resultFiltersAtom } from '~hooks/use-doctor-results';

import { ReactComponent as IconFilter } from '~svg/icons/icon-filter.svg';
import { SanityDoctorSearchSort } from '~types/sanity';

export const DoctorSortDropdown = () => {
  const [{ sort }, setResultFilters] = useAtom(resultFiltersAtom);
  const defaultSort: SanityDoctorSearchSort = 'Experience';
  const sorts: SanityDoctorSearchSort[] = ['Distance', 'Experience'];

  useEffect(() => {
    if (sort === null) {
      setResultFilters((prev) => ({
        ...prev,
        sort: defaultSort, // set default Sort on initial render
      }));
    }
  }, [sort, defaultSort, setResultFilters]);

  const handleDropdownClick = (selectedSort: SanityDoctorSearchSort) => {
    if (window.gtag) {
      window.gtag('event', 'Map Sort Change', {
        sort: selectedSort,
      });
    }
    setResultFilters((prev) => ({
      ...prev,
      sort: selectedSort,
    }));
  };

  return (
    <DropdownButton
      label="Sort"
      onClick={handleDropdownClick}
      items={sorts.map(sort => {
        const label = `Sort by ${sort}`;
        return { label, value: sort };
      })}
      selectedValue={sort}
      MobileIcon={IconFilter}
      mobileModal={true}
      sx={{
        'button[data-id="mobile-icon-button"]': {
          variant: 'buttons.iconOutline',
          display: ['flex', null, 'none'],
        },
        'button[data-id="dropdown-button"]': {
          variant: 'buttons.outline',
          display: ['none', null, 'flex'],
          boxShadow: 'none',

          ':hover': {
            boxShadow: 'none',
          },
        },
      }}
    />
  );
};

